// Indian States and their major cities/locations
export const INDIA_STATES_CITIES = {
  'Andhra Pradesh': [
    'Visakhapatnam', 'Vijayawada', 'Guntur', 'Nellore', 'Kurnool',
    'Rajahmundry', 'Tirupati', 'Kakinada', 'Kadapa', 'Anantapur',
    'Eluru', 'Ongole', 'Nandyal', 'Machilipatnam', 'Adoni',
    'Tenali', 'Proddatur', 'Chittoor', 'Hindupur', 'Bhimavaram',
  ],
  'Arunachal Pradesh': [
    'Itanagar', 'Naharlagun', 'Pasighat', 'Tawang', 'Ziro',
    'Along', 'Bomdila', 'Tezu', 'Aalo', 'Changlang',
  ],
  'Assam': [
    'Guwahati', 'Silchar', 'Dibrugarh', 'Jorhat', 'Nagaon',
    'Tinsukia', 'Tezpur', 'Bongaigaon', 'Dhubri', 'North Lakhimpur',
    'Karimganj', 'Sivasagar', 'Goalpara', 'Barpeta', 'Diphu',
  ],
  'Bihar': [
    'Patna', 'Gaya', 'Bhagalpur', 'Muzaffarpur', 'Purnia',
    'Darbhanga', 'Bihar Sharif', 'Arrah', 'Begusarai', 'Katihar',
    'Munger', 'Chhapra', 'Danapur', 'Saharsa', 'Hajipur',
    'Dehri', 'Siwan', 'Motihari', 'Nawada', 'Bagaha',
  ],
  'Chhattisgarh': [
    'Raipur', 'Bhilai', 'Bilaspur', 'Korba', 'Durg',
    'Rajnandgaon', 'Jagdalpur', 'Raigarh', 'Ambikapur', 'Dhamtari',
    'Mahasamund', 'Chirmiri', 'Dongargarh', 'Kawardha',
  ],
  'Goa': [
    'Panaji', 'Margao', 'Vasco da Gama', 'Mapusa', 'Ponda',
    'Bicholim', 'Curchorem', 'Canacona', 'Pernem', 'Quepem',
  ],
  'Gujarat': [
    'Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Bhavnagar',
    'Jamnagar', 'Junagadh', 'Gandhinagar', 'Anand', 'Nadiad',
    'Morbi', 'Surendranagar', 'Bharuch', 'Mehsana', 'Bhuj',
    'Porbandar', 'Palanpur', 'Valsad', 'Navsari', 'Godhra',
  ],
  'Haryana': [
    'Faridabad', 'Gurgaon', 'Panipat', 'Ambala', 'Yamunanagar',
    'Rohtak', 'Hisar', 'Karnal', 'Sonipat', 'Panchkula',
    'Bhiwani', 'Bahadurgarh', 'Jind', 'Thanesar', 'Kaithal',
    'Rewari', 'Palwal', 'Sirsa', 'Fatehabad',
  ],
  'Himachal Pradesh': [
    'Shimla', 'Solan', 'Dharamshala', 'Mandi', 'Palampur',
    'Baddi', 'Nahan', 'Kullu', 'Chamba', 'Una',
    'Hamirpur', 'Bilaspur', 'Kangra', 'Manali',
  ],
  'Jharkhand': [
    'Ranchi', 'Jamshedpur', 'Dhanbad', 'Bokaro', 'Deoghar',
    'Phusro', 'Hazaribagh', 'Giridih', 'Ramgarh', 'Medininagar',
    'Chaibasa', 'Chatra', 'Gumla', 'Lohardaga',
  ],
  'Karnataka': [
    'Bengaluru', 'Mysuru', 'Hubballi', 'Mangaluru', 'Belagavi',
    'Kalaburagi', 'Ballari', 'Vijayapura', 'Shivamogga', 'Tumakuru',
    'Davanagere', 'Bidar', 'Raichur', 'Hassan', 'Udupi',
    'Chitradurga', 'Kolar', 'Mandya', 'Dharwad', 'Hospet',
  ],
  'Kerala': [
    'Thiruvananthapuram', 'Kochi', 'Kozhikode', 'Thrissur', 'Kollam',
    'Palakkad', 'Alappuzha', 'Malappuram', 'Kannur', 'Kasaragod',
    'Kottayam', 'Idukki', 'Pathanamthitta', 'Wayanad', 'Ernakulam',
  ],
  'Madhya Pradesh': [
    'Bhopal', 'Indore', 'Jabalpur', 'Gwalior', 'Ujjain',
    'Sagar', 'Dewas', 'Satna', 'Ratlam', 'Rewa',
    'Murwara', 'Singrauli', 'Burhanpur', 'Khandwa', 'Bhind',
    'Chhindwara', 'Guna', 'Shivpuri', 'Vidisha', 'Chhatarpur',
  ],
  'Maharashtra': [
    'Mumbai', 'Pune', 'Nagpur', 'Nashik', 'Thane',
    'Aurangabad', 'Solapur', 'Kalyan', 'Navi Mumbai', 'Pimpri-Chinchwad',
    'Amravati', 'Kolhapur', 'Akola', 'Latur', 'Jalgaon',
    'Nanded', 'Dhule', 'Ahmednagar', 'Chandrapur', 'Satara',
    'Sangli', 'Wardha', 'Malegaon', 'Jalna', 'Ratnagiri',
  ],
  'Manipur': [
    'Imphal', 'Thoubal', 'Bishnupur', 'Churachandpur', 'Senapati',
    'Ukhrul', 'Kangpokpi', 'Kakching', 'Noney', 'Pherzawl',
  ],
  'Meghalaya': [
    'Shillong', 'Tura', 'Nongstoin', 'Jowai', 'Baghmara',
    'Nongpoh', 'Williamnagar', 'Ampati', 'Resubelpara',
  ],
  'Mizoram': [
    'Aizawl', 'Lunglei', 'Champhai', 'Serchhip', 'Kolasib',
    'Saiha', 'Lawngtlai', 'Mamit', 'Khawzawl',
  ],
  'Nagaland': [
    'Kohima', 'Dimapur', 'Mokokchung', 'Tuensang', 'Wokha',
    'Zunheboto', 'Mon', 'Phek', 'Kiphire', 'Longleng',
  ],
  'Odisha': [
    'Bhubaneswar', 'Cuttack', 'Rourkela', 'Brahmapur', 'Sambalpur',
    'Puri', 'Balasore', 'Bhadrak', 'Baripada', 'Jharsuguda',
    'Jeypore', 'Barbil', 'Rayagada', 'Koraput', 'Angul',
  ],
  'Punjab': [
    'Ludhiana', 'Amritsar', 'Jalandhar', 'Patiala', 'Bathinda',
    'Hoshiarpur', 'Mohali', 'Pathankot', 'Moga', 'Firozpur',
    'Batala', 'Gurdaspur', 'Abohar', 'Malout', 'Barnala',
  ],
  'Rajasthan': [
    'Jaipur', 'Jodhpur', 'Kota', 'Bikaner', 'Ajmer',
    'Udaipur', 'Bhilwara', 'Alwar', 'Bharatpur', 'Sikar',
    'Sri Ganganagar', 'Pali', 'Tonk', 'Hanumangarh', 'Churu',
    'Jhunjhunu', 'Beawar', 'Nagaur', 'Barmer', 'Jaisalmer',
  ],
  'Sikkim': [
    'Gangtok', 'Namchi', 'Mangan', 'Gyalshing', 'Rangpo',
    'Jorethang', 'Nayabazar', 'Ravangla',
  ],
  'Tamil Nadu': [
    'Chennai', 'Coimbatore', 'Madurai', 'Tiruchirappalli', 'Salem',
    'Tirunelveli', 'Tiruppur', 'Vellore', 'Erode', 'Thoothukkudi',
    'Dindigul', 'Thanjavur', 'Ranipet', 'Sivakasi', 'Karur',
    'Udhagamandalam', 'Hosur', 'Nagercoil', 'Kanchipuram', 'Kumbakonam',
  ],
  'Telangana': [
    'Hyderabad', 'Warangal', 'Nizamabad', 'Khammam', 'Karimnagar',
    'Ramagundam', 'Mahabubnagar', 'Nalgonda', 'Adilabad', 'Suryapet',
    'Miryalaguda', 'Mancherial', 'Jagtial', 'Kothagudem', 'Siddipet',
    'Bhongir', 'Narayanpet', 'Sangareddy', 'Vikarabad', 'Medak',
  ],
  'Tripura': [
    'Agartala', 'Dharmanagar', 'Udaipur', 'Kailasahar', 'Belonia',
    'Sabroom', 'Sonamura', 'Ambassa', 'Khowai',
  ],
  'Uttar Pradesh': [
    'Lucknow', 'Kanpur', 'Agra', 'Varanasi', 'Prayagraj',
    'Ghaziabad', 'Noida', 'Meerut', 'Bareilly', 'Aligarh',
    'Moradabad', 'Saharanpur', 'Gorakhpur', 'Faizabad', 'Jhansi',
    'Mathura', 'Muzaffarnagar', 'Firozabad', 'Rampur', 'Shahjahanpur',
    'Hapur', 'Etawah', 'Mirzapur', 'Bulandshahr', 'Sambhal',
  ],
  'Uttarakhand': [
    'Dehradun', 'Haridwar', 'Roorkee', 'Haldwani', 'Rudrapur',
    'Kashipur', 'Rishikesh', 'Kotdwar', 'Nainital', 'Mussoorie',
    'Pithoragarh', 'Almora', 'Uttarkashi', 'Chamoli', 'Tehri',
  ],
  'West Bengal': [
    'Kolkata', 'Asansol', 'Siliguri', 'Durgapur', 'Bardhaman',
    'Malda', 'Baharampur', 'Habra', 'Kharagpur', 'Shantipur',
    'Dankuni', 'Dhulian', 'Ranaghat', 'Haldia', 'Raiganj',
    'Jalpaiguri', 'Darjeeling', 'Cooch Behar', 'Alipurduar',
  ],
  'Delhi': [
    'New Delhi', 'North Delhi', 'South Delhi', 'East Delhi', 'West Delhi',
    'Central Delhi', 'North East Delhi', 'North West Delhi', 'South West Delhi',
    'South East Delhi', 'Shahdara', 'Dwarka', 'Rohini', 'Preet Vihar',
    'Laxmi Nagar', 'Janakpuri', 'Pitampura', 'Vikaspuri',
  ],
  'Jammu & Kashmir': [
    'Srinagar', 'Jammu', 'Anantnag', 'Baramulla', 'Sopore',
    'Bandipore', 'Kathua', 'Udhampur', 'Rajouri', 'Punch',
    'Shopian', 'Pulwama', 'Kulgam', 'Ganderbal',
  ],
  'Ladakh': [
    'Leh', 'Kargil', 'Nubra', 'Zanskar', 'Drass',
  ],
  'Chandigarh': [
    'Chandigarh', 'Manimajra', 'Sector 17', 'Sector 22', 'Sector 35',
  ],
  'Puducherry': [
    'Puducherry', 'Karaikal', 'Mahe', 'Yanam', 'Oulgaret',
  ],
  'Andaman & Nicobar': [
    'Port Blair', 'Car Nicobar', 'Havelock Island', 'Neil Island', 'Diglipur',
  ],
  'Dadra & Nagar Haveli and Daman & Diu': [
    'Silvassa', 'Daman', 'Diu',
  ],
  'Lakshadweep': [
    'Kavaratti', 'Agatti', 'Amini', 'Andrott', 'Minicoy',
  ],
};

export const INDIA_STATES = Object.keys(INDIA_STATES_CITIES).sort();

export const getCitiesForState = (state) => {
  return INDIA_STATES_CITIES[state] || [];
};
